import styled, { css } from 'styled-components';

const ARROW_SIZE = '8px';
const Tooltip_backgroundColor = css`
  background-color: ${({ theme }) => theme.neutral_500};
`;

export const Tooltip = styled.div`
  &.tooltip-container {
    box-shadow: unset;
    border: none;
    color: ${({ theme }) => theme.neutral_100};
    ${Tooltip_backgroundColor}
    border-radius: 8px;
    padding: 8px;
    pointer-events: none;
    font-size: 14px;
    font-weight: 300;

    .arrow-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;

      .arrow {
        width: ${ARROW_SIZE};
        height: ${ARROW_SIZE};
        ${Tooltip_backgroundColor}
        transform: rotate(45deg);
      }
    }

    &[data-popper-placement^='top'] > .arrow-wrapper {
      bottom: calc(-${ARROW_SIZE} / 2);

      .arrow {
        border-radius: ${ARROW_SIZE} 0 4px;
      }
    }

    &[data-popper-placement^='right'] > .arrow-wrapper {
      left: calc(-${ARROW_SIZE} / 2);

      .arrow {
        border-radius: 0 ${ARROW_SIZE} 0 4px;
      }
    }

    &[data-popper-placement^='bottom'] > .arrow-wrapper {
      border-radius: 4px 0 ${ARROW_SIZE};
      top: calc(-${ARROW_SIZE} / 2);

      .arrow {
        border-radius: 4px 0 ${ARROW_SIZE};
      }
    }

    &[data-popper-placement^='left'] > .arrow-wrapper {
      right: calc(-${ARROW_SIZE} / 2);

      .arrow {
        border-radius: 0 4px 0 ${ARROW_SIZE};
      }
    }
  }
`;
